// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CardFormComponent } from './card-form.component';
import { ButtonModule } from '../../fields/button/button.module';
import { NotificationModule } from '../../../../component/notification/notification.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        NotificationModule,
    ],
    declarations: [
      CardFormComponent
    ],
    exports: [
      CardFormComponent
    ]
})
export class CardFormModule { }
